import { hideLoader } from './loader.action'

export const responseHandler = (dispatch, response, method) => {
  // if (response.status >= 200 && response.status <= 305) {
  dispatch(method(response))
  // } else {
  //   let error = new Error(response.statusText)
  //   error.response = response
  //   throw error
  // }
}

export const apiErrorHandler = (dispatch, error) => {
  dispatch(hideLoader())
  throw error
}
